import React from "react";
import {css, Theme} from "@emotion/react";

import {Col, Container, Row} from "@pg-design/grid-module";
import {mb, pr} from "@pg-design/helpers-css";
import {isEqual} from "@pg-mono/nodash";

import {Heading} from "../../../../atoms/Heading";
import {ILatestQuery} from "../../../../utils/latest_query";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {OfferListSubType} from "../../types/OfferListSubType";
import {OfferListHeaderText} from "./OfferListHeaderText";

export interface OfferListHeaderProps {
    propertiesCount: number | null;
    offerCount: number;
    isMap?: boolean;
    selectedRegion: ISelectedRegion[];
    latestQuery: ILatestQuery;
    offerListSubType?: OfferListSubType;
    onHeaderClick?: () => void;
}

export const OfferListHeader = React.memo((props: OfferListHeaderProps) => {
    return (
        <Container css={headingWrapper}>
            <Row>
                <Col sm={4} md={9} lg={13}>
                    <Heading type="div" padding="0">
                        <OfferListHeaderText {...props} />
                    </Heading>
                </Col>
            </Row>
        </Container>
    );
}, isEqual);

//Added isEqual to provide better user experience when user changes filter frequently during one search session

export const offersCount = css`
    font-size: 1.6rem;
    padding-top: 0.5rem;
    line-height: 1.2;
`;

const headingWrapper = (theme: Theme) => css`
    width: 100%;
    ${pr(4)};
    ${mb(1)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mb(4)};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Col, Container, Row} from "@pg-design/grid-module";
import {mb, pr} from "@pg-design/helpers-css";
import {isEqual} from "@pg-mono/nodash";

import {Heading} from "../../../../atoms/Heading";
import {ILatestQuery} from "../../../../utils/latest_query";
import {ISelectedRegion} from "../../actions/offer_list_selected_data_actions";
import {OfferListSubType} from "../../types/OfferListSubType";
import {OfferListHeaderText} from "./OfferListHeaderText";

export interface OfferListHeaderProps {
    propertiesCount: number | null;
    offerCount: number;
    isMap?: boolean;
    selectedRegion: ISelectedRegion[];
    latestQuery: ILatestQuery;
    offerListSubType?: OfferListSubType;
    onHeaderClick?: () => void;
}

export const OfferListHeader = React.memo((props: OfferListHeaderProps) => {
    return (
        <Container css={headingWrapper}>
            <Row>
                <Col sm={4} md={9} lg={13}>
                    <Heading type="div" padding="0">
                        <OfferListHeaderText {...props} />
                    </Heading>
                </Col>
            </Row>
        </Container>
    );
}, isEqual);

//Added isEqual to provide better user experience when user changes filter frequently during one search session

export const offersCount = css`
    font-size: 1.6rem;
    padding-top: 0.5rem;
    line-height: 1.2;
`;

const headingWrapper = (theme: Theme) => css`
    width: 100%;
    ${pr(4)};
    ${mb(1)};

    @media (min-width: ${theme.breakpoints.md}) {
        ${mb(4)};
    }
`;
